<template>
	<v-app>
		<Header/>
		<div>
			<v-tabs
				grow
				hide-slider
				center-active
				show-arrows
				v-model="tab"
				class="cursive-heavy accent"
			>
				<v-tab
					v-for="item in tabs"
					:key="item.title"
					class="tab"
					active-class="active-tab"
				>
					{{ item.title }}
				</v-tab>
			</v-tabs>
			<v-tabs-items
				v-model="tab"
			>
				<v-tab-item
					v-for="item in tabs"
					:key="item.title"
				>
					<component :is="item.component"></component>
				</v-tab-item>
			</v-tabs-items>
			<v-btn
				color="primary"
				fab
				large
				class="bus-btn"
				@click="showBusSchedule = true"
			>
				<v-icon>
					fa-solid fa-van-shuttle
				</v-icon>
			</v-btn>
		</div>
		<v-overlay
			:value="showBusSchedule"
		>
			<v-card
				light
			>
				<v-card-title>Shuttle Times</v-card-title>
				<v-card-text>
					<p>A shuttle between the venue and hotel is provided on the day of the wedding, departure and pickup times are listed below.</p>
					<p><strong>Leaving the Hotel for the Wedding:</strong></p>
					<ul>
						<li>3:00PM</li>
						<li>3:50PM</li>
					</ul>
					<br/>
					<p><strong>Leaving the Wedding for the Hotel:</strong></p>
					<ul>
						<li>8:30PM</li>
						<li>10:00PM</li>
						<li>11:00PM</li>
					</ul>
				</v-card-text>
				<v-btn
					text
					style="position: absolute; top: 1em; right: .5em"
					@click="showBusSchedule = false"
				>
					<v-icon>fa-regular fa-x</v-icon>
				</v-btn>
			</v-card>
		</v-overlay>
	</v-app>
</template>

<script>

	//	 #CelebratingSchwartz
	import Header from "./components/Header.vue";
	import Registry from "./components/tabs/Registry.vue";
	import Gallery from "./components/tabs/Gallery.vue";
	import Info from "./components/tabs/Info.vue";
	// import RSVP from "./components/tabs/RSVP.vue";
	import Accommodations from "./components/tabs/Accommodations.vue";

	export default {
		name: 'App',

		components: {Header},
		created() {
			const today = new Date()
			if ((today.getMonth() === 8 && ![1, 2].includes(today.getDate()))
				|| (today.getMonth() === 7 && today.getDate() !== 31)) {
				this.showBusSchedule = false
			}
		},
		data: () => ({
			tab: null,
			showBusSchedule: true,
			tabs: [
				{title: "Wedding & Reception", component: Info, path: "/"},
				{title: "Accommodations", component: Accommodations, path: "/hotel"},
				// {title: "RSVP", component: RSVP, path: "/rsvp"},
				{title: "Registry & Honeymoon Fund", component: Registry, path: "/registry"},
				{title: "Photo Gallery", component: Gallery, path: "/gallery"}
			]
		}),
	};
</script>

<style>

	#app {
		max-width: 100vw;
		min-height: 100vh;
		overflow-x: hidden;
	}

	.active-tab {
		color: var(--v-primary-darken2) !important;
		text-decoration: underline !important;
	}

	.bus-btn {
		position: fixed !important;
		bottom: 1em;
		right: 1em;
	}

	.cursive {
		font-family: "Great Vibes", serif;
	}

	.cursive-heavy {
		font-family: "Yellowtail", serif;
	}

	.tab {
		font-size: 2.5vh !important;
		text-transform: none !important;
	}

	.v-slide-group__prev--disabled {
		display: none !important;
	}

	.v-tabs-bar__content {
		background: linear-gradient(0deg, var(--v-primary-lighten2) 0%, white 25%, white 100%);
	}
</style>
